import React, { useContext } from "react";
import "./index.css";
import { BrowserRouter as Router, Switch } from "react-router-dom";

import LandingPage from "./Pages/Hom/Homepage";
import Login from "./Pages/Login/Login";
import AdminLogin from "./Pages/Admin/AdminLogin";
import Register from "./Pages/Register/Register";
import Exchange from "./Pages/Exchange/Exchange";
import Trade from "./Pages/Trade/Trade";
// import TradeBuy from "./Pages/Trade/TradeBuy";
import TradeSell from "./Pages/Trade/TradeSell";
// import GuestBuy from "./Pages/ExchangeTrade/TradeBuy";
import GuestSell from "./Pages/ExchangeTrade/TradeSell";
import History from "./Pages/History/History";
import Referred from "./Pages/Referred";
import AdminHome from "./Pages/Admin/AdminHome";
import AdminRate from "./Pages/Admin/AdminSetRate";
import AdminTransactions from "./Pages/Admin/AdminTransactions";
import Settings from "./Pages/Settings/Settings";
import Home from "./Pages/Home/Home";
import PrivateRoute from "./components/authRoute/privateRoute";
import PublicRoute from "./components/authRoute/publicRoute";
import AdminRoute from "./components/authRoute/adminRoute";
import Referrals from "./components/Referrals";
import { UserContext } from "./components/UserContext";
import { SnackbarProvider } from 'notistack';
import Cookies from "js-cookie"

function App() {
  const user = useContext(UserContext);
  return (
    <SnackbarProvider>
    <Router>
      <Switch>
        <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={false}
          exact
          component={LandingPage}
          path="/"
        />
        <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={Login}
          path="/login"
        />
        <PublicRoute
          user={user.admin || Cookies.get("admin--auth")}
          restricted={true}
          admin={true}
          exact
          component={AdminLogin}
          path="/admin"
        />
        <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={Register}
          path="/register/email=:email"
        />
        <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={Register}
          path="/register/ref=:ref"
        />
         <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={Register}
          path="/register"
        />
         {/* <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={GuestBuy}
          path="/guest/buy/:currency"
        /> */}
        <PublicRoute
          user={user.user || Cookies.get("auth")}
          restricted={true}
          exact
          component={GuestSell}
          path="/guest/sell/:currency"
        />
        <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={Home}
          path="/dashboard"
        />
        <AdminRoute
          admin={user.admin || Cookies.get("admin--auth")}
          exact
          component={AdminHome}
          path="/admin/dashboard"
        />
        <AdminRoute
          admin={user.admin || Cookies.get("admin--auth")}
          exact
          component={AdminTransactions}
          path="/admin/transactions"
        />
        <AdminRoute
          admin={user.admin || Cookies.get("admin--auth")}
          exact
          component={AdminRate}
          path="/admin/rate"
        />
        <AdminRoute
          admin={user.admin || Cookies.get("admin--auth")}
          exact
          component={Referrals}
          path="/admin/referrals"
        />
        <PublicRoute
          user={user.user  || Cookies.get("auth")}
          exact
          component={Exchange}
          path="/exchange"
        />
        {/* <PublicRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={Transaction}
          path="/transaction"
        /> */}
        <PrivateRoute user={user.user || Cookies.get("auth")} exact component={Trade} path="/trade" />
        <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={History}
          path="/history"
        />
        <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={Referred}
          path="/referrals"
        />
        <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={Settings}
          path="/settings"
        />
        {/* <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={userReferal}
          path="/refered"
        /> */}
        {/* <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={TradeBuy}
          path="/trade/buy/:currency"
        /> */}
        <PrivateRoute
          user={user.user || Cookies.get("auth")}
          exact
          component={TradeSell}
          path="/trade/sell/:currency"
        />
      </Switch>
    </Router>
    </SnackbarProvider>
  );
}

export default App;
